import React from "react";
import {
	IonPage,
	IonContent,
	IonIcon,
	IonLabel,
	IonInput,
	IonButton,
	isPlatform,
} from "@ionic/react";
import { chevronBack } from "ionicons/icons";
import { signInWithPhoneNumber } from "../../firebase";
import { phoneAuth } from "../../Store/Actions";
import { connect } from "react-redux";
import { checkMediaQuery, validateMobileNumber } from "../../utils";
import { PLEASE_ENTER_VALID_MOBILE_NUMBER } from "../../constants";
import { ToastMessage } from "../../utils/toastMessage";
import { Loader } from "../../utils/loader";
const MobilenumberInput: React.FC = (props: any) => {
	const [mobileNumber, setMobileNumber] = React.useState("");
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	const [loader, showLoader] = React.useState(false);

	// console.log("Props verificationId ..... ", props);

	React.useEffect(() => {
		if (props.result && props.result.verificationId) {
			props.history.push("/otp");
		}
	}, [props.result]);

	const handleMobileNumberChange = (mobileNumber: string) => {
		if (/^\d+$/.test(mobileNumber) && mobileNumber.length <= 10) {
			setMobileNumber(mobileNumber);
		}
	};

	function formatError(error: any) {
		// console.log("Error ... 42 ===", error);
		if (error.includes("auth/")) {
			const splitted = error.split("/");
			if (splitted && splitted.length === 2) {
				setToast({
					showToast: true,
					toastMessage: splitted.pop()?.split("-").join(" "),
					severity: "danger",
				} as any);
				return;
			}
		}
	}

	const validateMobileAndGetOpt = async () => {
		try {
			if (mobileNumber.length === 9 && !!validateMobileNumber(mobileNumber)) {
				showLoader(true);
				const result = await signInWithPhoneNumber("+971" + mobileNumber);
				if (typeof result === "object") {
					if (result) {
						showLoader(false);
						props.phoneAuth({ result, mobileNumber });
						props.history.push({
							pathname: "/otp",
						});
					}
				} else {
					formatError(result);
				}
			} else {
				setToast({
					showToast: true,
					toastMessage: PLEASE_ENTER_VALID_MOBILE_NUMBER,
					severity: "warning",
				});
			}
		} catch (error: any) {
			setToast({
				showToast: true,
				toastMessage: JSON.stringify(error),
				severity: "danger",
			});
		}
	};
	return (
		<>
			<IonPage className="mobile_num_responsive">
				<IonContent forceOverscroll={false}>
					<div className="mobilenum_parent_container">
						<div className="getstarted_mobilenum wholeApp">
							<img
								src={
									checkMediaQuery()
										? "/images/gray_backarrow.svg"
										: "/images/back_arrow.svg"
								}
								style={{ height: 14, width: 7 }}
								onClick={() => props.history.goBack()}
							/>
							<IonLabel className="getstartedtext_mobilenum">Get Started</IonLabel>
						</div>
						<div className="mobilenum_label_input">
							<IonLabel className="mobilenum_label">Mobile Number</IonLabel>
							<div className="mobilenum_input_container">
								<IonLabel className="mobilenum_input" color="tertiary">
									+971
								</IonLabel>
								<IonInput
									type="tel"
									maxlength={10}
									className="mobilenum_text"
									placeholder="99999 99999"
									color="tertiary"
									onIonChange={(event) =>
										handleMobileNumberChange((event.target as any).value)
									}
									value={mobileNumber}
								/>
							</div>
						</div>
						<div className="mobilenum_continuebtn continueBtnDiv">
							<IonButton
								className="mobilenum_continue_text continueBtn"
								onClick={() => validateMobileAndGetOpt()}
								color="primary"
							>
								Continue
							</IonButton>
						</div>
						<div className="mobilenum_msg_container">
							<IonLabel className="mobilenum_msg" color="tertiary">
								A One Time Password (OTP) will be sent to your phone number
							</IonLabel>
						</div>
					</div>
				</IonContent>
				<ToastMessage
					showToast={toast.showToast}
					ToastMessage={toast.toastMessage}
					severity={toast.severity}
					onDidDismiss={() => {
						setToast({
							showToast: false,
							toastMessage: "",
							severity: "",
						});
					}}
				/>
				{loader ? <Loader loader={loader} /> : null}
			</IonPage>
		</>
	);
};

export default connect(
	({ auth: { result, mobileNumber } }: any) => {
		return { result, mobileNumber };
	},
	{ phoneAuth }
)(MobilenumberInput);
